import { useState } from "react";
import { useNavigate } from "react-router-dom";
import SubscriptionNavigation from "./SubscriptionNavigation";

const SubscriptionCoffee = () => {
  const cupsPerDayList = [
    { id: "1", title: "Coffee #1 - 1kg - £25/kg" },
    { id: "2", title: "Coffee #2 - 250g - £35/kg" },
    { id: "3", title: "Coffee #3 - 1kg - £40/kg " },
  ];

  const [preferredOption] = useState(
    localStorage.getItem("subscriptionPreferredOption")
  );
  const [preferredCoffee, setPreferredCoffee] = useState(
    localStorage.getItem("subscriptionPreferredCoffee")
  );
  const navigate = useNavigate();

  if (!preferredOption) {
    navigate("/subscription/subscription-options");
  }

  const handleFormSubmission = (e) => {
    e.preventDefault();
    localStorage.setItem("subscriptionPreferredCoffee", preferredCoffee);
    navigate("/subscription/summary");
  };

  return (
    <div className="container">
      <div className="col-6 mx-auto">
        <h2>Coffee preference</h2>

        <form onSubmit={handleFormSubmission}>
          <div>
            <div className="mb-3">
              <p>Do you have a coffee preference?</p>
              {cupsPerDayList.map((item) => (
                <div key={item.id} className="form-check">
                  <input
                    name="preferredCoffee"
                    id={`preferredCoffee-${item.id}`}
                    className="form-check-input"
                    type="radio"
                    value={item.id}
                    checked={item.id === preferredCoffee}
                    onChange={(e) => {
                      setPreferredCoffee(e.target.value);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor={`preferredCoffee-${item.id}`}
                  >
                    {item.title}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <SubscriptionNavigation
            buttonBackUrl="/subscription/subscription-options"
            buttonNextEnabled={preferredCoffee}
          />
        </form>
      </div>
    </div>
  );
};

export default SubscriptionCoffee;
